module.exports = __webpack_public_path__ + "img/upload.0e34c124.svg";